import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

/**
 * Wraps admin-only routes. Redirects to home if user is not logged in or not admin.
 */
export default function AdminGate({ children }) {
  const { isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated || !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return children;
}
